import styled from 'styled-components';

export const ImageStyled = styled.div`
    height: 36px;
    width: 36px;
    display: flex;
    justify-content: center;
    align-items: center;
    box-sizing: border-box;
`;